(function () {
  function scrollProgress() {
    var el = document.documentElement;
    var body = document.body;
    var scrollTop = window.scrollY || el.scrollTop || body.scrollTop || 0;
    var scrollHeight = Math.max(
      el.scrollHeight,
      body.scrollHeight,
      el.offsetHeight,
      body.offsetHeight
    );
    var clientHeight = el.clientHeight || window.innerHeight;
    var maxScroll = Math.max(0, scrollHeight - clientHeight);
    if (maxScroll <= 8) {
      return scrollTop / Math.max(1, window.innerHeight);
    }
    return scrollTop / maxScroll;
  }

  function updateOne(root) {
    var raw = parseFloat(root.dataset.threshold || "0.2");
    var threshold = Number.isNaN(raw) ? 0.2 : raw;
    if (threshold > 1) threshold = threshold / 100;
    var show = scrollProgress() >= threshold;
    root.classList.toggle("is-visible", show);
    root.setAttribute("aria-hidden", show ? "false" : "true");
  }

  function updateAll() {
    document.querySelectorAll("[data-sticky-shop-cta]").forEach(updateOne);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      updateAll();
    });
  }

  if (!window.__stickyShopCtaListeners) {
    window.__stickyShopCtaListeners = true;
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    document.addEventListener("shopify:section:load", onScroll);
  }

  updateAll();
})();
